import { render, staticRenderFns } from "./dcpthgz2026.vue?vue&type=template&id=594e478a&scoped=true"
import script from "./dcpthgz2026.vue?vue&type=script&lang=js"
export * from "./dcpthgz2026.vue?vue&type=script&lang=js"
import style0 from "./dcpthgz2026.vue?vue&type=style&index=0&id=594e478a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e478a",
  null
  
)

export default component.exports